export const home_page = {
  // Header
  title: "Account",
  subtitle:
    "Manage your personal information, company profile, and password from one place.",
  back_to_marketplace_aria: "Back to marketplace",

  // Sticky save (company profile)
  save_changes: "Save Changes",
  save_success: "Company profile saved.",

  // Misc kept for backwards compat with other references
  support: "Support",
  sign_out: "Sign out",
} as const;
